import React from 'react';
import { Moon, Sparkles } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const handlePurchase = () => {
    window.location.href = 'https://www.clickylee.com/cart/50840452596002:1';
  };
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-cream-200 shadow-sm" data-id="element-82">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between" data-id="element-83">
        <div className="flex items-center space-x-2" data-id="element-84">
          <Moon className="w-6 h-6 text-amber-600" data-id="element-85" />
          <span className="font-bold text-lg text-navy-900 uppercase tracking-tight" data-id="element-86">
            Dormir Sin Pensar
          </span>
        </div>

        <div className="flex items-center space-x-4" data-id="element-87">
          <div className="hidden sm:flex items-center text-sm text-amber-700 font-medium" data-id="element-88">
            <Sparkles className="w-4 h-4 mr-1" data-id="element-89" />
            <span data-id="element-90">¡5 Bonos Gratis!</span>
          </div>
          <Button size="md" className="bg-amber-600 hover:bg-amber-700 text-white shadow-md" onClick={handlePurchase} data-id="element-91">
            Descargar por $14.999
          </Button>
        </div>
      </div>
    </header>;
}